import type * as React from 'react';

import { createPalette, PalettePositionWidth } from '@gitbook/react-uikit';
import type { MarkProps } from '@gitbook/slate-react';

import { SelectionPalettePicker } from '../common';
import { useInlineCommands } from '../useInlineCommands';
import type { InlineControlsMarkData } from './types';

/**
 * Component being rendered around the temporary mark created when typing "/".
 */
export function InlineControlsPicker(props: MarkProps): React.ReactElement {
    const { editor } = props;
    const markData = props.mark.data.toFrozenObject<InlineControlsMarkData>();

    const getInlineCommands = useInlineCommands({ editor });

    return (
        <SelectionPalettePicker
            {...props}
            getPalette={(_props, getRange) => {
                const commands = getInlineCommands({ getRange }).filter((command) =>
                    markData.controls.includes(command.key)
                );
                const palette = createPalette({
                    position: { width: PalettePositionWidth.MEDIUM },
                    groups: [{ key: 'inline-controls', commands }],
                });

                return palette;
            }}
        />
    );
}
